import { createTheme } from '@mui/material/styles';

export const getTheme = (mode: 'light' | 'dark') =>
    createTheme({
        palette: {
            mode,
            ...(mode === 'light'
                ? {
                    background: {
                        // default: '#f5f5f5',
                    },
                }
                : {
                    background: {
                        default: '#1f2a38',
                    },
                }),
        },
    });
